module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searches.length),
      expression: "searches.length"
    }],
    staticClass: "checkboxes searches clickable",
    class: {
      visible: _vm.searchesVisible, collapsable: _vm.collapsable
    }
  }, [_c('h2', {
    staticClass: "shadow",
    on: {
      "click": function($event) {
        _vm.searchesVisible = !_vm.searchesVisible
      }
    }
  }, [_vm._v("Remembered searches")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchesVisible || !_vm.collapsable),
      expression: "searchesVisible || !collapsable"
    }],
    staticClass: "panel shadow"
  }, _vm._l((_vm.searches), function(exportable) {
    return _c('div', {
      staticClass: "remembered-search",
      on: {
        "click": function($event) {
          _vm.applyFilter(exportable)
        }
      }
    }, [_c('div', [_vm._l((_vm.decodeExportable(exportable)), function(ref) {
      var label = ref[0];
      var values = ref[1];

      return _c('span', [_c('strong', [_vm._v(_vm._s(label) + ":")]), _vm._v(" " + _vm._s(values.join(', ')) + ";\n        ")])
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.decodeExportable(exportable).length == 0),
        expression: "decodeExportable(exportable).length==0"
      }]
    }, [_vm._v("\n          Empty\n        ")])], 2), _vm._v(" "), _c('i', {
      staticClass: "material-icons clickable",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteSearch(exportable)
        }
      }
    }, [_vm._v("close")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec0531a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FavoritedSearches.vue
// module id = 542
// module chunks = 1